import { render } from "./MenuManagementEdit.vue?vue&type=template&id=59f0f291"
import script from "./MenuManagementEdit.vue?vue&type=script&lang=js"
export * from "./MenuManagementEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/setting/menuManagement/components/MenuManagementEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59f0f291"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59f0f291', __exports__)) {
    console.log('reload')
    api.reload('59f0f291', __exports__)
  }
  
  module.hot.accept("./MenuManagementEdit.vue?vue&type=template&id=59f0f291", () => {
    console.log('re-render')
    api.rerender('59f0f291', render)
  })

}


export default __exports__